import { render } from "./OtherMeasurements.vue?vue&type=template&id=52235f49"
import script from "./OtherMeasurements.vue?vue&type=script&lang=ts"
export * from "./OtherMeasurements.vue?vue&type=script&lang=ts"
script.render = render

export default script